// @flow
import React from 'react';

import { MdEvent, MdGroup } from 'react-icons/lib/md';

import type { STUDENT_TYPE } from '../../types/student';

import Passenger from '../Passenger';
import RouteEmptyList from '../RouteStopsCardContent/routeEmptyList';
import styles from './routeCardPassengers.css';
import { getUserImage } from '../../utils';


type RouteCardPassengersPropTypes = {
  students: Array<STUDENT_TYPE>
};

const RouteCardPassengers = ({
  students = [],
}: RouteCardPassengersPropTypes) => (
  <div className={styles.passengers}>
    {
      typeof students !== 'undefined' && students.length > 0
        ? students.map(student => (
          <Passenger
            {...student}
            key={student.id}
            firstName={student.first_name}
            lastName={student.last_name}
            Icon={MdEvent}
            onPressRightIcon={undefined}
            pictureURL={getUserImage(student.profile_picture)}
          />
        )) : (
          <RouteEmptyList
            Icon={MdGroup}
            title="No hay estudiantes asignados a esta parada"
          />
        )
    }
  </div>
);

export default RouteCardPassengers;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteCardPassengers/index.jsx